module.exports = __webpack_public_path__ + "img/want_to_learn1.f2de4ecb.jpg";